import React, { useEffect, useRef } from 'react';
import './LendiInstallmentTeaser.css';

export function LendiTeaserButton({
  expanded,
  onToggle,
}: {
  expanded: boolean;
  onToggle: () => void;
}) {
  return (
    <button className="history-toggle lendi-teaser-toggle" onClick={onToggle}>
      <span>{expanded ? 'Zwiń' : 'Oblicz ratę kredytu'}</span>
      <div className={`history-arrow ${expanded ? 'expanded' : ''}`}>
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path d="M3.9 6.05L7.5 9.65L11.1 6.05" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </button>
  );
}

export function LendiTeaserPanel({
  expanded,
  embedHtml,
  onToggle,
}: {
  expanded: boolean;
  embedHtml: string;
  onToggle: () => void;
}) {
  const embedRef = useRef<HTMLDivElement>(null);
  const embedLoaded = useRef(false);

  useEffect(() => {
    if (expanded && !embedLoaded.current && embedRef.current) {
      embedLoaded.current = true;

      const parser = new DOMParser();
      const doc = parser.parseFromString(embedHtml, 'text/html');
      const scriptSrc = doc.querySelector('script')?.src;
      const widgetDiv = doc.querySelector('.lendi-widget');

      if (widgetDiv) {
        const div = document.createElement('div');
        Array.from(widgetDiv.attributes).forEach(attr => div.setAttribute(attr.name, attr.value));
        embedRef.current.appendChild(div);
      }

      if (scriptSrc) {
        const script = document.createElement('script');
        script.src = scriptSrc;
        script.async = true;
        embedRef.current.appendChild(script);
      }
    }
  }, [expanded, embedHtml]);

  return (
    <>
      <div className={`lendi-teaser-expand ${expanded ? 'open' : ''}`}>
        <button className="lendi-teaser-close-sticky" onClick={onToggle}>
          <span>Zwiń obliczanie raty</span>
          <div className="lendi-teaser-arrow expanded">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M3.9 6.05L7.5 9.65L11.1 6.05" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </button>
        <div className="lendi-teaser-expand-inner">
          <div ref={embedRef}></div>
          <div className="lendi-teaser-powered">
            Oferty dostarczane przez <a href="https://www.lendi.pl" target="_blank" rel="noopener noreferrer">Lendi.pl</a>
          </div>
        </div>
      </div>
    </>
  );
}
